import { render, staticRenderFns } from "./StrOccupationAutocomplete.vue?vue&type=template&id=36dc8b9e&"
import script from "./StrOccupationAutocomplete.vue?vue&type=script&lang=js&"
export * from "./StrOccupationAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports